import React, { Component } from 'react';
import { MessageBox } from '@eg/elements/MessageBox';
import "./Outcomes.scss";

class ServerError extends Component {
  render() {
    return (
      <div className="esc_container outerContainer">
        <div className="esc_container esc_container--l"id="main-outcomes-container">
          <div className="text-checkout-failure">
            <MessageBox>
              <h1>Aus technischen Gründen konnte Ihre Anfrage leider nicht erfolgreich ausgeführt werden</h1>
              <p>Versuchen Sie es bitte zu einem späteren Zeitpunkt erneut</p>
              <p>Falls Sie Fragen haben, wenden Sie sich bitte an unseren Support:</p>
              <p>ERGO Direkt Versicherung AG <br/>Karl-Martell-Straße 60<br/>90344 Nürnberg</p>
              <p>Telefon: 0800/999 4580 <small>(Mo-Fr 7-20 Uhr, gebührenfrei)</small></p>
              <p>E-Mail: <a className="mail-link" href="mailto:internetschutzbrief@ergo.de">internetschutzbrief@ergo.de</a></p>
              <p>Vielen Dank für Ihr Verständnis!<br />Ihr Sicherer-Surfen-Team</p>
            </MessageBox>
          </div>
        </div>
      </div>
    )
  }
}

export default ServerError;
